<template>
	<div class="landing-head" :class="`landing-head_align_${logoAlignment}`">
		<inline-svg
			class="landing-head__logo"
			:class="`landing-head__logo_color_${logoColor}`"
			:src="require('@/assets/logos/logo-inline-to-be-colored.svg')"
		/>
	</div>
</template>

<script>
export default {
	name: 'LandingHead',

	props: {
		logoAlignment: {
			type: String,
			default: 'center',
			validator(v) {
				return ['left', 'center'].includes(v)
			},
		},

		logoColor: {
			type: String,
			default: 'primary',
			validator: (value) => ['primary', 'accent', 'white'].includes(value),
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-head {
	padding-top: var(--size-18);
	padding-bottom: var(--size-18);

	box-sizing: content-box;
	height: var(--size-28);

	&_align {
		&_left {
			text-align: left;
		}

		&_center {
			text-align: center;
		}
	}

	&__logo {
		width: auto;
		height: 100%;

		&_color {
			&_primary {
				color: var(--Text-Primary-100);
			}

			&_accent {
				color: var(--Text-Accent);
			}

			&_white {
				color: var(--Fill-White);
			}
		}
	}
}
</style>
